import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/landing/Navbar";
import HeroSection from "@/components/landing/HeroSection";
import TrustIndicators from "@/components/landing/TrustIndicators";
import ServicesOverview from "@/components/landing/ServicesOverview";
import HowItWorks from "@/components/landing/HowItWorks";
import WhyChooseUs from "@/components/landing/WhyChooseUs";
import TestimonialsSection from "@/components/landing/TestimonialsSection";
import FAQSection from "@/components/landing/FAQSection";
import FinalCTA from "@/components/landing/FinalCTA";
import ContactSection from "@/components/landing/ContactSection";
import JoinUs from "@/components/landing/JoinUs";
import Footer from "@/components/landing/Footer";
import WhatsAppWidget from "@/components/landing/WhatsAppWidget";
import AssistancePopup from "@/components/landing/AssistancePopup";
import PatientsElderlyCare from "@/components/pages/PatientsElderlyCare";
import HomeNursing from "@/components/pages/HomeNursing";
import NannyBabySitting from "@/components/pages/NannyBabySitting";
import PrivacyPolicy from "@/components/pages/PrivacyPolicy";
import TermsConditions from "@/components/pages/TermsConditions";

function HomePage() {
  return (
    <>
      <HeroSection />
      <TrustIndicators />
      <ServicesOverview />
      <HowItWorks />
      <WhyChooseUs />
      <TestimonialsSection />
      <FAQSection />
      <JoinUs />
      <FinalCTA />
      <ContactSection />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-white">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services/patients-elderly-care" element={<PatientsElderlyCare />} />
            <Route path="/services/home-nursing" element={<HomeNursing />} />
            <Route path="/services/nanny-baby-sitting" element={<NannyBabySitting />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppWidget />
        <AssistancePopup />
      </div>
    </BrowserRouter>
  );
}

export default App;
